// src/pages/ProphetStoriesPage.js
import React, { useState } from "react";

const ProphetStoriesPage = () => {
  const stories = [
    { name: "Prophet Adam (AS)", story: "The first human created by Allah. He lived in Paradise and taught us how to say sorry when we make mistakes." },
    { name: "Prophet Idris (AS)", story: "He was very smart and was the first to write with a pen. He loved learning!" },
    { name: "Prophet Nuh (AS)", story: "Built a big boat (ark) to save animals and good people from a huge flood!" },
    { name: "Prophet Hud (AS)", story: "Told his people to be kind and stop being proud. They didn't listen and a big wind came." },
    { name: "Prophet Saleh (AS)", story: "Allah gave his people a special camel, but they were mean and hurt it. Uh oh!" },
    { name: "Prophet Ibrahim (AS)", story: "He broke the idols and was thrown into fire, but Allah kept him safe!" },
    { name: "Prophet Lut (AS)", story: "Told people to do good and was saved when they didn't listen." },
    { name: "Prophet Ismail (AS)", story: "Helped build the Kaaba with his dad, Ibrahim. A very brave boy!" },
    { name: "Prophet Ishaq (AS)", story: "Son of Ibrahim. A kind and peaceful man who loved Allah." },
    { name: "Prophet Yaqub (AS)", story: "Had 12 sons and was very patient when one of them went missing." },
    { name: "Prophet Yusuf (AS)", story: "Had amazing dreams, was very handsome and became a big helper in Egypt!" },
    { name: "Prophet Shuayb (AS)", story: "Told people not to cheat in business. Be honest like him!" },
    { name: "Prophet Ayyub (AS)", story: "Got very sick but never complained. Allah healed him because he was so patient." },
    { name: "Prophet Dhul-Kifl (AS)", story: "Always did the right thing and helped others. A real hero!" },
    { name: "Prophet Musa (AS)", story: "Split the sea with his stick and saved his people from the mean Pharaoh!" },
    { name: "Prophet Harun (AS)", story: "Helped his brother Musa. He was a great speaker and very wise." },
    { name: "Prophet Dawud (AS)", story: "Was a brave king and prophet. He fought Goliath and received the Zabur." },
    { name: "Prophet Sulaiman (AS)", story: "Could talk to animals and control the wind! A very wise king." },
    { name: "Prophet Ilyas (AS)", story: "Taught people to worship only Allah. He never gave up." },
    { name: "Prophet Al-Yasa (AS)", story: "Helped continue Ilyas' message and guided his people with kindness." },
    { name: "Prophet Yunus (AS)", story: "He was swallowed by a big fish and prayed to Allah. He was saved when he said sorry." },
    { name: "Prophet Zakariya (AS)", story: "He was very old but still prayed for a child. Allah gave him Prophet Yahya!" },
    { name: "Prophet Yahya (AS)", story: "A kind and pure boy who always spoke the truth." },
    { name: "Prophet Isa (AS)", story: "Born without a father. Spoke as a baby and healed the sick with Allah's help." },
    { name: "Prophet Muhammad (SAW)", story: "The last prophet. Kind, honest, and brought the Quran to teach us about Allah." },
  ];

  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleStory = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="bg-yellow-50 min-h-screen p-6" dir="ltr">
      <h1 className="text-4xl font-bold text-center text-yellow-600 mb-10 font-[Comic Sans MS,cursive,sans-serif]">
        Facts about prophets
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {stories.map((prophet, index) => (
          <div
            key={index}
            className={`transition-all duration-300 ease-in-out bg-white rounded-3xl shadow-lg hover:shadow-2xl p-6 text-center cursor-pointer border-4 border-yellow-200 ${
              expandedIndex === index ? "bg-yellow-100" : ""
            }`}
            onClick={() => toggleStory(index)}
          >
            <h2 className="text-xl font-bold text-yellow-700 mb-2 font-[Comic Sans MS,cursive,sans-serif]">
              {prophet.name}
            </h2>
            {expandedIndex === index && (
              <p className="text-gray-700 text-base font-sans leading-relaxed">{prophet.story}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProphetStoriesPage;
